import { Link } from "@tanstack/react-router";
import { ArrowUpRight } from "lucide-react";
import type { ReactNode } from "react";

/** Shared page furniture for the calendar and fortune tools. */
export function AlmanacHeader({
  title,
  description,
  icon,
}: {
  title: string;
  description: ReactNode;
  icon?: ReactNode;
}) {
  return (
    <header className="almanac-header">
      <div className="min-w-0 flex-1">
        <h1>{title}</h1>
        <div className="almanac-description">{description}</div>
      </div>
      {icon ? (
        <span className="almanac-header-icon" aria-hidden="true">
          {icon}
        </span>
      ) : null}
    </header>
  );
}

export function AlmanacLink({
  to,
  title,
  description,
  icon,
  prominent = false,
}: {
  to: "/xem-ngay" | "/van-khi" | "/tong-hop/van-khi" | "/tong-hop/la-ban";
  title: string;
  description: string;
  icon: ReactNode;
  prominent?: boolean;
}) {
  return (
    <Link to={to} className={`almanac-link${prominent ? " almanac-link--prominent" : ""}`}>
      <span className="almanac-link-icon" aria-hidden="true">
        {icon}
      </span>
      <span className="min-w-0 flex-1">
        <span className="block text-sm font-semibold text-foreground">{title}</span>
        <span className="mt-1 block text-xs leading-5 text-muted-foreground">{description}</span>
      </span>
      <ArrowUpRight className="size-[18px] shrink-0 text-primary" aria-hidden="true" />
    </Link>
  );
}
